export default "__VITE_ASSET__BgIlVpXG__"